// Pflichtfeld-Panel (amber): weist auf leere Pflichtfelder hin, die vor der SAP-Uebertragung
// geprueft/befuellt werden muessen (Bauplan Punkt 3c). Pflichtfeld-Set bewusst enger als die
// Zielspalten der SAP-Staging-Tabelle (ebeln/ebelp/menge/netpr/eeind) — labnr/matnr/mfrpn/waers
// werden separat (Abgleich/HTN) behandelt. Betroffene Zellen faerbt AbLineTable zusaetzlich gelb.

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card, SectionTitle } from '../ui';

export const REQUIRED_FIELDS = ['ebeln', 'ebelp', 'menge', 'netpr', 'eeind'];

const AbMissingFieldsPanel = ({ isDarkMode, t, lines, ignored, noRuleset }) => {
  if (ignored || noRuleset || !Array.isArray(lines) || lines.length === 0) return null;
  const missing = REQUIRED_FIELDS.filter((f) => lines.some((l) => l[f] === null || l[f] === undefined || l[f] === ''));
  if (missing.length === 0) return null;

  return (
    <Card isDarkMode={isDarkMode} className={isDarkMode ? 'border-amber-400/30' : 'border-amber-200'}>
      <SectionTitle isDarkMode={isDarkMode}>
        <span className={`flex items-center gap-2 ${isDarkMode ? 'text-amber-300' : 'text-amber-600'}`}>
          <AlertTriangle className="w-4 h-4" />{t('abPdf.missingFieldsTitle')}
        </span>
      </SectionTitle>
      <p className={`text-sm ${isDarkMode ? 'text-white/70' : 'text-slate-600'}`}>
        {t('abPdf.missingFieldsMsg', { fields: missing.map((f) => t(`ab.field.${f}`)).join(', ') })}
      </p>
    </Card>
  );
};

export default AbMissingFieldsPanel;
